import Swal from 'sweetalert2';

async function simpleAlert({ opcoes = {}, titulo = '', mensagem = '' }) {
  await Swal.fire({
    title: titulo,
    text: mensagem,
    icon: 'warning',
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'OK',
    ...opcoes,
  });
}

export default simpleAlert;
